export enum enteteTableauListeImmeublesQuotesPartsResidentielEnum {
	referenceImmeuble = 'Immeuble',
	quotePartResidentiel = 'Quote part'
}